import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";

//namespace SlotGames {

    export class WildIcy_1Screen extends SlotGameType1_1Screen {

        
        protected override helpFactory: IHelpFactory = new WildIcyHelpFactory();
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "WildIcy");

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }

        // protected PrepareFonts(resourceManager: ResourceManager): void {

        //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

        // }

           //SEND COLOR FOR RSA 
           protected override color: RewardColor =
           {
               color: "#0A7CBF",
               coloroutherStroke: "black",
               colorinnerStroke: "#031333",
           }

    }

    
    //Help Colorized
    class WildIcyHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new WildIcyHelp(params);
        }
    }

    class WildIcyHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(6, 42, 115),rgb(8, 61, 166), rgb(7, 86, 242),rgb(8, 61, 166),rgb(6, 42, 115)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
//}